import { getRequest } from "../core/api/requestConfig";

export const getPayAreas = () => {
  return new Promise<any>((resolve, reject) => {
    getRequest("/legacy/api/v1/payareas")
      .then(payAreas => {
        if (payAreas && payAreas.length) {
          return resolve(payAreas);
        } else {
          return resolve(null);
        }
      })
      .catch(error => {
        console.log(error);
        return reject(null);
      });
  });
};
